<template>
  <a-card :bordered="false">
    <!-- 左侧面板 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="refresh" style="margin-bottom: 10px">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <mtc-form-item label="label.dictionaryName" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input :placeholder="$t('label.pleaseEnterDictionaryName')" v-model="queryParam.dictName"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <mtc-form-item label="label.dictionaryNumber" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input :placeholder="$t('label.pleaseEnterDictionaryNum')" v-model="queryParam.dictCode"></a-input>
            </mtc-form-item>
          </a-col>
        </a-row>
      </a-form>
      <BaseTable ref="baseTable"
                 @searchReset="searchReset"
                 :mainTable="mainTable"
                 :tableColumns="columns"
                 :tableData="tableData">
        <!-- 左侧操作按钮 -->
        <template #leftButton>
          <mtc-button class="mg-r8" @click="handleAdd" type="primary" icon="plus" text="button.add" />
          <mtc-button class="mg-r8" @click="handleExportXls('字典信息')" type="primary" icon="download" text="button.export" />
          <a-upload name="file"
                    :showUploadList="false"
                    :multiple="false"
                    :headers="tokenHeader"
                    :action="importExcelUrl"
                    @change="handleImportExcel">
            <mtc-button type="primary" class="mg-r8" icon="import" text="button.import" />
          </a-upload>
          <mtc-button class="mg-r8" type="primary" icon="sync" @click="refleshCache()" text="button.refreshTheCache" />
          <mtc-button class="mg-r8" type="primary" icon="hdd" @click="openDeleteList()" text="button.recycleBin" />
        </template>
        <span slot="action" slot-scope="{record}">
          <!--<a @click="handleEdit(record)">-->
          <!--<a-icon type="edit" />-->
          <!--{{ $t('button.edit') }}-->
          <!---->
          <!--</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <!--<a @click="editDictItem(record)"><a-icon type="setting" />  {{ $t('button.zidianpeizhi') }}</a>-->
          <mtc-button @click="editDictItem(record)" type="link" size="small" text="button.zidianpeizhi"></mtc-button>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
            <!--<a>{{ $t('button.delete') }}</a>-->
            <mtc-button type="link" size="small" text="button.delete"></mtc-button>
          </a-popconfirm>
        </span>
      </BaseTable>
    </div>
    <dict-modal ref="modalForm" @ok="modalFormOk"></dict-modal>
    <!-- 字典类型 -->
    <dict-item-list ref="dictItemList"></dict-item-list>
    <dict-delete-list ref="dictDeleteList" @refresh="() => loadData()"></dict-delete-list>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DictModal from './modules/DictModal'
import DictItemList from './DictItemList'
import DictDeleteList from './DictDeleteList'
import { getAction } from '@/api/manage'
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types'
import Vue from 'vue'
import { MTC_AUTH } from '@api/servers'
import { BaseTable } from '@comp/mtcModule'

export default {
  name: 'DictList',
  mixins: [JeecgListMixin],
  components: { DictModal, DictItemList, DictDeleteList, BaseTable },
  data() {
    return {
      mainTable: 'sys_dict',
      // 列表数据
      tableData: params => this.getData(params),
      description: '这是数据字典页面',
      visible: false,
      // 查询条件
      queryParam: {
        dictCode: '',
        dictName: ''
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 50,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          slotName: 'tableHeader.dictionaryName',
          // title: '字典名称',
          align: 'left',
          width: 200,
          dataIndex: 'dictName',
          scopedSlots: { customRender: 'dictName', title: 'tableHeader.dictionaryName' }
        },
        {
          slotName: 'tableHeader.dictionaryNumber',
          // title: '字典编号',
          align: 'left',
          width: 200,
          dataIndex: 'dictCode',
          scopedSlots: { title: 'tableHeader.dictionaryNumber' }
        },
        {
          slotName: 'tableHeader.description',
          // title: '描述',
          align: 'left',
          dataIndex: 'description',
          scopedSlots: { customRender: 'description', title: 'tableHeader.description' }
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          width: 200,
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
        }
      ],
      dict: '',
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      url: {
        list: `${MTC_AUTH}sys/dict/list`,
        delete: `${MTC_AUTH}sys/dict/delete`,
        exportXlsUrl: `${MTC_AUTH}sys/dict/exportXls`,
        importExcelUrl: `${MTC_AUTH}sys/dict/importExcel`,
        refleshCache: `${MTC_AUTH}sys/dict/refleshCache`,
        queryAllDictItems: `${MTC_AUTH}sys/dict/queryAllDictItems`
      }
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG[ 'domianURL' ]}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    getData(baseParams) {
      let params = {
        ...baseParams,
        ...this.queryParam
      }
      return getAction(this.url.list, params)
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      if (this.superQueryParams) {
        param[ 'superQueryParams' ] = encodeURI(this.superQueryParams)
        param[ 'superQueryMatchType' ] = this.superQueryMatchType
      }
      return filterObj(param)
    },
    //取消选择
    cancelDict() {
      this.dict = ''
      this.visible = false
      this.loadData()
    },
    //编辑字典数据
    editDictItem(record) {
      this.$refs.dictItemList.edit(record)
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      this.queryParam.dictName = ''
      this.queryParam.dictCode = ''
      this.refresh()
    },
    refresh() {
      this.$refs.baseTable.refresh()
    },
    openDeleteList() {
      this.$refs.dictDeleteList.show()
    },
    refleshCache() {
      getAction(this.url.refleshCache)
        .then((res) => {
          if (res.success) {
            //重新加载缓存
            getAction(this.url.queryAllDictItems).then((res) => {
              if (res.success) {
                Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
                Vue.ls.set(UI_CACHE_DB_DICT_DATA, res.result, 7 * 24 * 60 * 60 * 1000)
              }
            })
            this.$message.success('刷新缓存完成！')
          }
        })
        .catch((e) => {
          this.$message.warn('刷新缓存失败！')
          console.log('刷新失败', e)
        })
    }
  },
  watch: {
    openKeys(val) {
      console.log('openKeys', val)
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>